import {Form, Formik} from "formik";
import React from "react";
import Card from "../../components/card/Card";
import ModalMsg from "../../components/ModalMsg";
import NsField from "../../components/fields/NsField";

export default function ModificaStrutturaClasseImpExpView({
                                                              show,
                                                              setShow,
                                                              modalMsg,
                                                              translate,
                                                              formikRef,
                                                              SignupSchema,
                                                              salvaClasseTipoImpExpDati,
                                                              optionsClass,
                                                              bottoniSx,
                                                              bottoniDx,
                                                          }) {

    return (
        <div>
            <ModalMsg
                show={show}
                handleClose={() => setShow(false)}
                testo={modalMsg}/>
            <Card
                icon={'fas fa-building'}
                title={'Inserisci Struttura Classe Organizzazione'}
                bottoniSx={bottoniSx}
                bottoniDx={bottoniDx}
            >
                <Formik
                    initialValues={{
                        id_struttura_classe_tipo_imp_exp: '',
                        id_classe_tipo_imp_exp: '',
                        id_classe_tipo_imp_exp_madre: ''
                    }}
                    innerRef={formikRef}
                    validationSchema={SignupSchema}
                    onSubmit={salvaClasseTipoImpExpDati}
                >
                    {({errors, touched, values, submitCount}) => (
                        <Form className="row g-3">
                            <div className="col-md-6">
                                <NsField
                                    name={"id_classe_tipo_imp_exp_madre"}
                                    label={"Classe Organizzazione Madre*:"}
                                    as={"select"}
                                    options={(optionsClass ? optionsClass.map(o => {
                                        return {
                                            label: o.descrizione,
                                            value: o.id_classe_tipo_imp_exp,
                                        };
                                    }) : [])}
                                    placeholder={translate("Seleziona una classe")}
                                    formikRef={formikRef}
                                    values={values}
                                    errors={errors}
                                    touched={touched}
                                    submitCount={submitCount}
                                />
                            </div>
                            <div className="col-md-6">
                                <NsField
                                    name={"id_classe_tipo_imp_exp"}
                                    label={"Classe Organizzazione Figlia*:"}
                                    as={"select"}
                                    options={(optionsClass ? optionsClass.map(o => {
                                        return {
                                            label: o.descrizione,
                                            value: o.id_classe_tipo_imp_exp,
                                        };
                                    }) : [])}
                                    placeholder={translate("Seleziona una classe")}
                                    formikRef={formikRef}
                                    values={values}
                                    errors={errors}
                                    touched={touched}
                                    submitCount={submitCount}
                                />
                            </div>
                        </Form>
                    )}
                </Formik>
            </Card>
        </div>
    );
}